<div class="health-page">
    <header class="dashboard-header">
        <div>
            <h1>Health Status</h1>
            <p>Platform dependency status for operational monitoring</p>
        </div>
        <button type="button" class="export-button" (click)="refresh()" [disabled]="loading">
            {{ loading ? 'Refreshing…' : 'Refresh' }}
        </button>
    </header>

    <div class="health-error" *ngIf="errorMessage && !platformHealth">
        <p>{{ errorMessage }}</p>
        <button type="button" class="export-button" (click)="refresh()">Retry</button>
    </div>

    <section class="overall-banner" [class]="statusClass(platformHealth?.overall_status)" *ngIf="platformHealth">
        <div>
            <span class="overall-label">Overall Status</span>
            <strong>{{ labelFor(platformHealth.overall_status) }}</strong>
        </div>
        <div class="meta-row">
            <span>Environment: {{ platformHealth.environment || '—' }}</span>
            <span>Version: {{ platformHealth.version || '—' }}</span>
            <span>Timestamp: {{ platformHealth.timestamp | reportingDate }}</span>
        </div>
    </section>

    <!-- Frontend is always shown (local). Backend stack cards (API, DB, Storage, Redis,
         Celery, Scheduler, …) require a successful platform-health payload. -->
    <section class="health-grid">
        <article class="health-card" *ngFor="let card of displayCards()">
            <header>
                <h3>{{ card.title }}</h3>
                <span class="status-badge" [class]="statusClass(component(card.key).status)">
          {{ labelFor(component(card.key).status) }}
        </span>
            </header>
            <p>{{ component(card.key).detail || '—' }}</p>
            <p class="muted" *ngIf="component(card.key).backend">
                Backend: {{ component(card.key).backend }}
            </p>
        </article>
    </section>
</div>
